import React from "react";
import { Heading } from "@pepdirect/ui/heading";
import st from "./property.module.scss";

export function Property({
  children,
  label = "",
}: {
  children: string | JSX.Element;
  label?: string | JSX.Element;
}): JSX.Element {
  return (
    <div className={st.information}>
      <Heading size="xs" level="h3">
        {label}
      </Heading>
      <div className={st.details}>{children}</div>
    </div>
  );
}
